// functional programming utils

export const toTrue = (): boolean => true
export const toFalse = (): boolean => false

export const logError = (error: unknown): void => console.log(error)
